import styled from 'styled-components/native';
import style, { hpx } from './../../styles/index';

export const Container = styled.View`
  margin-top: ${hpx(20)};
  padding: 0 20px;
`;

export const DataContainer = styled.View`
  margin-bottom: ${hpx(20)};
`;

export const Category = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-size: ${style.fonts.xsmall};
  font-family: ${style.fontName.ubuntuBold};
  margin-bottom: ${hpx(8)};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: ${props => props.theme.colors.secondary}; 
  align-self: flex-start;
  padding: 4px 8px;
  border-radius: 4px;
  overflow: hidden; /* For border-radius to work with background-color if needed */
`;

export const Title = styled.Text`
  font-size: ${style.fonts.xxlarge};
  font-family: ${style.fontName.ubuntuBold};
  margin-bottom: ${hpx(12)};
  color: #1a1a1a;
  line-height: ${hpx(40)};
`;

export const Description = styled.Text`
  font-family: ${style.fontName.ubuntuRegular};
  font-size: ${style.fonts.medium};
  color: #666;
  line-height: ${hpx(26)};
`;
